export default __webpack_public_path__ + "static/media/referral.8e11bea7.svg";